<template>
    <div>
        <van-nav-bar
                title="添加临时地址"
                left-arrow
                class="my-nav"
                :fixed="true"
                @click-left="$router.back(-1)"
        />
        <div style="margin-top: 50px;">
            <van-address-edit
                    :address-info="address"
                    :area-list="areaList"
                    :show-delete="!$route.query||!address.isDefault"
                    :show-set-default="false"
                    @save="onSave"
            />
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    import bus from "../../bus";
    import {
        regionList,
        shippingAddressDetail,
    } from '../../api/address'

    export default {
        data() {
            return {
                address: {
                    name: "",
                    tel: "",
                    province: "",
                    city: "",
                    county: "",
                    areaCode: "",
                    postalCode: "",
                    addressDetail: "",
                    isDefault: true,
                },
                areaList: {},
            }
        },

        mounted() {
            regionList(d => {
                this.areaList = d;
                if (this.$route.query.id) {
                    shippingAddressDetail(this.$route.query.id, d => {
                        let obj = this.address;
                        obj.id = d.id;
                        obj.name = d.name;
                        obj.tel = d.phone;
                        if (d.region) {
                            let region = d.region.split("-");
                            obj.province = region[0];
                            obj.city = region[1];
                            obj.county = region[2];
                            obj.areaCode = this.getAreaCode(obj.county);
                        }
                        obj.addressDetail = d.address;
                        obj.isDefault = d.enabled;
                    })
                }
            })

        },
        methods: {
            onSave(content) {
                let id = 0;
                let name = content.name;
                let tel = content.tel;
                let region = content.province + "-" + content.city + "-" + content.county;
                let address = content.addressDetail;
                let enabled = false;
                let obj = {id, name, tel, region,address,enabled};
                bus.state.tempAddress = obj;
                bus.state.enableAddress = Object.assign({}, obj, {region:obj.region.split(',')[0].replace(/-/g, " ")});
                Toast('临时收货地址添加成功!');
                setTimeout(() => this.$router.back(-1), 2000);
            },
        }
    }
</script>

<style lang="less" scoped>

</style>